/** Cola serie: nunca hay dos tareas en vuelo a la vez, y se ejecutan en orden de llegada. */
export class SerialQueue {
  private tail: Promise<unknown> = Promise.resolve();
  private count = 0;
  /** Máximo de tareas simultáneas observado (útil en pruebas: debe ser 1). */
  maxRunning = 0;
  private running = 0;

  get pending(): number {
    return this.count;
  }

  push<T>(task: () => Promise<T>): Promise<T> {
    this.count++;
    const run = this.tail.then(async () => {
      this.running++;
      this.maxRunning = Math.max(this.maxRunning, this.running);
      try {
        return await task();
      } finally {
        this.running--;
        this.count--;
      }
    });
    this.tail = run.catch(() => undefined);
    return run;
  }

  /** Se resuelve cuando todo lo encolado hasta ahora ha terminado. */
  idle(): Promise<void> {
    return this.tail.then(() => undefined);
  }
}
